// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import { get } from 'utilities/objects'
import PostTileHorImageMedium from 'components/PostTile/PostTileHorImageMedium'

class PostsSectionB extends React.Component {
	componentDidMount() {
		// Scroll:
		this.raf = window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			window.oRequestAnimationFrame
		this.lastScrollTop = ( window.pageYOffset || document.documentElement.scrollTop )

		if ( this.raf ) {
			this.checkScroll()
		}
	}

	checkScroll = () => {
		let scrollTop = ( window.pageYOffset || document.documentElement.scrollTop )

		if ( this.lastScrollTop === scrollTop ) {
			this.raf.call( window, this.checkScroll )

			return
		} else {
			if ( this.lastScrollTop > scrollTop ) {
				// Scrolling up:

				if ( document.body.classList.contains( 'with-popular-fixed-bottom' ) ) {
					let bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop,
						sectionBOffsetTop = this.sectionBRef.getBoundingClientRect().top + document.documentElement.scrollTop,
						secondaryOffsetTop = this.secondaryRef.offsetTop,
						scrollFromSectionB = bodyScrollTop - sectionBOffsetTop,
						secondaryTop = scrollFromSectionB + secondaryOffsetTop

					document.body.classList.remove( 'with-popular-fixed-top' )
					document.body.classList.remove( 'with-popular-fixed-bottom' )
					document.body.classList.add( 'with-popular-relative-top' )
					this.secondaryRef.setAttribute( 'style', `top: ${secondaryTop}px` )
				}
			} else if ( this.lastScrollTop < scrollTop ) {
				// Scrolling down:

				if ( document.body.classList.contains( 'with-popular-fixed-top' ) ) {
					let bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop,
						sectionBOffsetTop = this.sectionBRef.getBoundingClientRect().top + document.documentElement.scrollTop,
						secondaryOffsetTop = this.secondaryRef.offsetTop,
						scrollFromSectionB = bodyScrollTop - sectionBOffsetTop,
						secondaryTop = scrollFromSectionB + secondaryOffsetTop

					document.body.classList.remove( 'with-popular-fixed-top' )
					document.body.classList.remove( 'with-popular-fixed-bottom' )
					document.body.classList.add( 'with-popular-relative-top' )
					this.secondaryRef.setAttribute( 'style', `top: ${secondaryTop}px` )
				}
			}

			this.lastScrollTop = scrollTop
			this.raf.call( window, this.checkScroll )
		}
	}

	handleSectionBTopEnter = ( props ) => {
		const { currentPosition, previousPosition } = props

		if ( 'inside' === currentPosition && 'above' === previousPosition ) {
			document.body.classList.remove( 'with-popular-fixed-top' )
			document.body.classList.remove( 'with-popular-fixed-bottom' )
			this.secondaryRef.removeAttribute( 'style' )
		}
	}

	handlePopularTopEnter = ( props ) => {
		const { currentPosition, previousPosition } = props

		if ( 'inside' === currentPosition && 'above' === previousPosition && document.body.classList.contains( 'with-popular-relative-top' ) ) {
			document.body.classList.add( 'with-popular-fixed-top' )
			document.body.classList.remove( 'with-popular-fixed-bottom' )
			document.body.classList.remove( 'with-popular-relative-top' )
			this.secondaryRef.removeAttribute( 'style' )
		}
	}

	handlePopularBottomEnter = ( { previousPosition, currentPosition, event } ) => {
		let windowHeight = Math.max( document.documentElement.clientHeight, window.innerHeight ),
			sectionBOffsetTop = this.sectionBRef.getBoundingClientRect().top + document.documentElement.scrollTop,
			secondaryHeight = this.secondaryRef.offsetHeight

		if ( secondaryHeight > windowHeight ) {
			document.body.classList.add( 'with-popular-fixed-bottom' )
			document.body.classList.remove( 'with-popular-fixed-top' )
			this.secondaryRef.removeAttribute( 'style' )
		} else {
			document.body.classList.add( 'with-popular-sticky' )
		}
	}

	render() {
		const { primaryMarkup, secondaryMarkup } = this.props

		return (
			<section className="posts-section-b" ref={ ( e ) => { this.sectionBRef = e } }>
				<div className="-waypoint-top">
					<Waypoint onEnter={ this.handleSectionBTopEnter } />
				</div>

				<div className="-primary">
					{ primaryMarkup &&
						<section className="-posts">
							<div className="-inner">
								<section className="with-vertical">
									{ primaryMarkup }
								</section>
							</div>
						</section>
					}
				</div>

				{ secondaryMarkup &&
					<div className="-secondary" ref={ ( e ) => { this.secondaryRef = e } }>
						<div className="-waypoint-top">
							<Waypoint onEnter={ this.handlePopularTopEnter } />
						</div>

						<div className="-heading">
							<div className="-e">
								<img className="site-logo" src={ `${siteData.images_url}logo/e-dark.svg` } alt="" />
							</div>

							<h2>Popular</h2>
						</div>

						<div className="-inner">
							<section>
								{ secondaryMarkup }
							</section>
						</div>

						<div className="-waypoint-bottom">
							<Waypoint onEnter={ this.handlePopularBottomEnter } />
						</div>
					</div>
				}
			</section>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( PostsSectionB )
